import { ActionStepSchema } from '@feedyou-ai/feedbot-schema'
import { Action, actionTypes } from './actions'
import { Mutable } from '@feedyou/utils'

export function actionReducer(step: Mutable<ActionStepSchema>, action: Action) {
  switch (action.type) {
    case actionTypes.SET_ACTION:
      return { ...step, action: action.action }

    default:
      return step
  }
}
